import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { cleanObj } from '../../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { asyncGetParams } from '../../../../../../services/param.service';
import { AccountContactPersonProps } from './props';
import { ChannelsInfoWeb } from '../../../../../../shared/types/modules/channels-web-information';

export const useAccountContactPerson = ({
    data,
    onChangeData,
    onChangeFormik,
}: AccountContactPersonProps) => {
    const [typesDocument, setTypesDocument] = useState<ISelect[]>([]);

    const onSubmit = (data: ChannelsInfoWeb) => {
        if (onChangeData) onChangeData(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(),
        enableReinitialize: true,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('document', data?.document || '');
        formik?.setFieldValue('typeDocument', data?.typeDocument || '');
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('cellPhone', data?.cellPhone || '');
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.DOCUMENT_TYPE).then((params) =>
            setTypesDocument(params)
        );
    }, []);

    return {
        formik,
        typesDocument,
    };
};
